module.exports = __webpack_public_path__ + "img/xqgl2.05aa060f.png";